import { render, staticRenderFns } from "./TabGoal.vue?vue&type=template&id=0064adda&scoped=true"
import script from "./TabGoal.vue?vue&type=script&lang=ts"
export * from "./TabGoal.vue?vue&type=script&lang=ts"
import style0 from "./TabGoal.vue?vue&type=style&index=0&id=0064adda&prod&lang=scss&scoped=true"
import style1 from "./TabGoal.vue?vue&type=style&index=1&id=0064adda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064adda",
  null
  
)

export default component.exports